<template>
  <div v-if="visible" class="navigating-indicator">
    <div class="progress">
      <div 
        class="progress-bar progress-bar-striped progress-bar-animated bg-primary" 
        role="progressbar" 
        style="width: 100%"
        aria-valuenow="100" 
        aria-valuemin="0" 
        aria-valuemax="100"
      >
        <span class="visually-hidden">Navigating...</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  visible?: boolean;
}

withDefaults(defineProps<Props>(), {
  visible: true
});
</script>

<style scoped>
.navigating-indicator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9998;
  height: 4px;
}

.progress {
  height: 4px;
  border-radius: 0;
  background-color: transparent;
}

.progress-bar {
  transition: none;
}

/* Ensure it appears above other content but below modals */
@media (max-width: 575.98px) {
  .navigating-indicator {
    height: 3px;
  }
  
  .progress {
    height: 3px;
  }
}
</style>